import uqnSplit from '../functions/uqnSplit';
export default function check(uqn) {
    let type, a, b, c, d;
    let e, f, sign;
    if (uqn > 999999) {
        type = 5;
        const uqnArray = uqnSplit(uqn);
        if (uqnArray.length != 7) {
            return false;
        }
        [b, a, c, d, e, f, sign] = uqnArray;
        if (b == 0) {
            return false;
        }
        if (c == 0 && d == 0) {
            return false;
        }
        if (e == 0 && f == 0) {
            return false;
        }
        if (d == 0 && f == 0) {
            return false;
        }
    }
    else {
        const uqnArray = uqnSplit(uqn);
        type = uqnArray[0];
        if (type == 0 || type == 5 || type > 6) {
            return false;
        }
        if (type == 1) {
            if (uqnArray.length != 3) {
                return false;
            }
        }
        else if (type < 4) {
            if (uqnArray.length != 6) {
                return false;
            }
            [type, a, b, c, d, sign] = uqnArray;
            if (a == 0 && b == 0) {
                return false;
            }
            if (c == 0 && d == 0) {
                return false;
            }
            if (b == 0 && d == 0) {
                return false;
            }
        }
        else if (type == 4) {
            if (uqnArray.length != 5) {
                return false;
            }
            let n;
            [type, a, b, sign, n] = uqnArray;
            if (a == 0 || b == 0 || sign > 3 || n < 2 || n > 3) {
                return false;
            }
        }
        else if (type == 6) {
            if (uqnArray.length != 5) {
                return false;
            }
            [type, a, b, c, sign] = uqnArray;
            if (sign > 1) {
                return false;
            }
            if (a == 0 || c == 0) {
                return false;
            }
            if (b * b - 4 * a * c >= 0) {
                return false;
            }
        }
        else if (type > 6) {
            return false;
        }
    }
    return true;
}
